import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { HomeComponent } from "./home/home.component";
import {
  ChangeDetectorRef,
  
//   Component,
  Inject,
  NgZone,
  OnDestroy,
  OnInit,
  WritableSignal,
  inject,
  signal
} from '@angular/core';

import {
  Router,
  RouterLink,
  // RouterOutlet,
} from '@angular/router';

import {
  MSAL_GUARD_CONFIG,
  MsalBroadcastService,
  MsalGuardConfiguration,
  MsalModule,
  MsalService
} from '@azure/msal-angular';

import {
  AccountInfo,
  AuthenticationResult,
  EventMessage,
  EventType,
  InteractionStatus,
  RedirectRequest
} from '@azure/msal-browser';

import {
  filter,
  takeUntil
} from 'rxjs/operators';
import { DriverService } from './service/driver.service';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-root',
    standalone: true,
    templateUrl: './app.component.html',
    styleUrl: './app.component.css',
    imports: [
      CommonModule, 
      RouterOutlet, 
      HomeComponent,
      // CommonModule,
      // FlexModule,
      // MatButtonModule,
      // MatIconModule,
      // MatToolbarModule,
      MsalModule,
      // RouterLink,
      // MatListModule,
      // MatToolbarModule,
      // RouterOutlet,
      // TranslateService,
      // TranslateModule,
    ]
})

export class AppComponent {
  title = 'driver';

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private msalBroadcastService: MsalBroadcastService,
    private authService: MsalService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private router: Router,
    // public themer: ThemeService
  //   private userProfileService: UserProfileService,
    private driverService: DriverService,
    // translate: TranslateService,
  ) { 

  }
  isIframe = false;
  private readonly _destroying$ = new Subject<void>();
  account: WritableSignal<AccountInfo | null> = signal(null);
  apexId = '';
  driverCountry = '';
  showEconomyKpi = false;

  ngOnInit(): void {
    console.log(`enter ngOnInit`);
    this.isIframe = window !== window.parent && !window.opener;

    // console.log(JSON.stringify(this.authService.instance.getActiveAccount()));
    // console.log(JSON.stringify(this.account()));

    // if(this.account()){
    //     console.log(this.account()!.username);
    // }
    // else{
    //     this.login();
    // }

    // let currentAccount = this.authService.instance.getActiveAccount();
    // if(currentAccount !== null){
        
    //     let index = currentAccount.username.lastIndexOf('@');
    //     let apexid = currentAccount.username.substring(0, index);
    //     this.apexId = apexid;
    //     this.store.dispatch(new SetUserApexId(this.apexId as string));
    //     console.log(`without login ${apexid}`);
    // }
    

    this.msalBroadcastService
        .inProgress$
        .pipe(
            filter((status: InteractionStatus) =>
                status === InteractionStatus.None
            ),
            takeUntil(this._destroying$)
        )
        .subscribe(() => {
            console.log(`InteractionStatus.None`);
            // console.log(JSON.stringify(this.authService.instance.getActiveAccount()));
            this.account.set(
                this.authService.instance.getActiveAccount()
            );

            console.log(JSON.stringify(this.authService.instance.getActiveAccount()));

            //   this.store.dispatch(new SetUserCountry(this.account().idTokenClaims.ctry as string));
            

            let currentAccount = this.authService.instance.getActiveAccount();
            if(currentAccount !== null){
                
                let index = currentAccount.username.lastIndexOf('@');
                let apexid = currentAccount.username.substring(0, index);
                this.apexId = apexid;
                // this.store.dispatch(new SetUserApexId(this.apexId as string));
                // console.log(`with login ${apexid}`);
                console.log(`set apexid in InteractionStatus.None`);
                localStorage.setItem('apexid', apexid);
            }

            this.cdr.detectChanges();

            // let apexid = localStorage.getItem("apexid");    
            // if(apexid !== null){
            //     // console.log(`apex id is not null`);
            //     this.apexId = apexid;
            //     let driverCountry = localStorage.getItem("driverCountry");
            //     if(driverCountry !== null){
            //         if(driverCountry === 'CN'){
            //             this.showEconomyKpi = true;
            //             this.cdr.detectChanges();
            //         }
            //         else{

            //         }
            //     }
            //     else{
            //         this.driverService.getDriverByApexId(this.apexId).subscribe(responseDriverObject => {
            //             let driverCountry = responseDriverObject.data[0].terminal.country;
            //             this.driverCountry = driverCountry
            //             // console.log(`get driver by apex id, country = ${this.driverCountry}`);
            //             if(this.driverCountry === 'CN'){
            //                 this.showEconomyKpi = true;
            //                 // console.log(`country is CN`);
            //                 localStorage.setItem('driverCountry', driverCountry)
            //                 this.cdr.detectChanges();
            //             }
            //         });
            //     }
                
            // }
            
        });

    this.msalBroadcastService
        .msalSubject$
        .pipe(
            filter((msg: EventMessage) =>
                msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
            )
        )
        .subscribe((msg: EventMessage) => {
            console.log(`EventType.ACQUIRE_TOKEN_SUCCESS`);
            localStorage.setItem('tokenExpiration', (msg.payload as any).expiresOn)
        }
            
            
        );

    this.msalBroadcastService
        .msalSubject$
        .pipe(
            filter((msg: EventMessage) =>
                msg.eventType === EventType.LOGIN_SUCCESS
            )
        )
        .subscribe((result: EventMessage) => {
            console.log(`EventType.LOGIN_SUCCESS`);
            const payload = result.payload as AuthenticationResult;
            this.authService.instance.setActiveAccount(payload.account);

            let currentAccount = payload.account;
            let index = currentAccount.username.lastIndexOf('@');
            let apexid = currentAccount.username.substring(0, index);
            this.apexId = apexid;
            localStorage.setItem('apexid', apexid)

            
        });
  

    // this.userProfileService.getUserProfileMe().subscribe(userProfileMe => {
    //   this.userProfileMe = userProfileMe[0];
    // });


    // console.log(JSON.stringify(this.authService.instance.getActiveAccount()));
    // let currentAccount = this.authService.instance.getActiveAccount();
    // if(currentAccount !== null){
        
    //     let index = currentAccount.username.lastIndexOf('@');
    //     let apexid = currentAccount.username.substring(0, index);
    //     this.apexId = apexid;
    //     // this.store.dispatch(new SetUserApexId(this.apexId as string));
    //     // console.log(`with login ${apexid}`);
    //     localStorage.setItem('apexid', apexid);
    // }


    // let apexId = localStorage.getItem("apexid");    
    // if(apexId !== null){
    //     // console.log(`apex id is not null`);
    //     this.apexId = apexId;
    //     this.driverService.getDriverByApexId(this.apexId).subscribe(responseDriverObject => {
    //         this.driverCountry = responseDriverObject.data[0].terminal.country;
    //         // console.log(`get driver by apex id, country = ${this.driverCountry}`);
    //         if(this.driverCountry === 'CN'){
    //             this.showEconomyKpi = true;
    //             // console.log(`country is CN`);
    //             this.cdr.detectChanges();
    //         }
    //     });
    // }
    
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  login() {
    console.log(`login clicked`);
      if (this.msalGuardConfig.authRequest)
          this.authService.loginRedirect(
              { ...this.msalGuardConfig.authRequest } as RedirectRequest
          );
      else
          this.authService.loginRedirect();
  }

  logout() {
      this.authService.logoutRedirect();
  }

  viewProfile() {
      this.ngZone.run(() => this.router.navigate(['profile']));
  }


}
